import { render } from "./CategoryEdit.vue?vue&type=template&id=374aa0fa&ts=true"
import script from "./CategoryEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryEdit.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryEdit.vue?vue&type=style&index=0&id=374aa0fa&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/scan/admin/CategoryEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "374aa0fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('374aa0fa', __exports__)) {
    console.log('reload')
    api.reload('374aa0fa', __exports__)
  }
  
  module.hot.accept("./CategoryEdit.vue?vue&type=template&id=374aa0fa&ts=true", () => {
    console.log('re-render')
    api.rerender('374aa0fa', render)
  })

}


export default __exports__